import { useEffect, useState } from 'react'
import { useCookies } from 'react-cookie'
import { useAuth0 } from '@auth0/auth0-react'
import { GetUser } from '../../../../apps/checkout/src/client/graphql/queries'
import { isInsecurelyValidJWT } from '../../helpers/jwt'

const idTokenCookieName = 'idToken'
const noop = (): void => undefined
const useQueryFallback = (): any => undefined

function useUser(useQuery = useQueryFallback as any): any {
  const [idToken, setIdToken] = useState<string | null>(null)
  const [cookies] = useCookies([idTokenCookieName])
  const { getIdTokenClaims, isLoading, loginWithRedirect, logout } = useAuth0()

  useEffect(() => {
    if (isLoading) {
      return
    }

    if (!idToken || !isInsecurelyValidJWT(idToken)) {
      getIdTokenClaims()
        .then(claims => setIdToken(claims.__raw))
        .catch(noop)
    }
  }, [getIdTokenClaims, idToken, isLoading, loginWithRedirect, logout])

  const idTokenFromCookie = cookies[idTokenCookieName]

  if (!idToken && idTokenFromCookie) {
    setIdToken(idTokenFromCookie)
  }

  const result = useQuery(GetUser, {
    context: { version: 2, headers: { Authorization: `Bearer ${idToken}` } },
    skip: !idToken,
  })

  return {
    user: result?.data?.currentUser,
  }
}

export default useUser
